"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemTranslationKeys = exports.FormTranslationKeys = void 0;
var form_translation_entity_1 = require("./form-translation.entity");
Object.defineProperty(exports, "FormTranslationKeys", { enumerable: true, get: function () { return form_translation_entity_1.FormTranslationKeys; } });
var system_translation_entity_1 = require("./system-translation.entity");
Object.defineProperty(exports, "SystemTranslationKeys", { enumerable: true, get: function () { return system_translation_entity_1.SystemTranslationKeys; } });
